import SimpleErrorState from '@components/SimpleErrorState';
import Table from '@components/table/Table';
import { Loadable, LoadableType } from '@data/loadable';
import { AutoSuggestSuggestion } from '@rio-cloud/rio-uikit/AutoSuggest';
import EmptyState from '@rio-cloud/rio-uikit/EmptyState';
import Spinner from '@rio-cloud/rio-uikit/Spinner';
import { getColumns } from '@utils/columns';
import _ from 'lodash';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import createColumn from '../../columns/createColumn';
import { DateRange } from '../../types';
import { DownloadButton } from './DownloadButton';
import { LOADING } from './reducer';
import { VEHICLE } from './selectors';
import { CoDriverDownloadPayload, CoDriverTableEntities, Status } from './types';

const downloadColumn = createColumn({
    key: 'coDriverDownload',
    dataField: 'download',
    // Workaround for empty table head
    labelId: ' ',
    valueExtractor: entity => _.get(entity, 'download', {}),

    formatter: ({ onClick, status }) => {
        return <DownloadButton onClick={onClick} status={status} />;
    },
    dataSort: false,
});

const TableElement: React.FC<{
    mappedEntities?: LoadableType<CoDriverTableEntities[]>;
    startDownload: (payload: CoDriverDownloadPayload) => void;
    selection: AutoSuggestSuggestion;
    dateRange: DateRange;
    status?: Record<string, Status>;
    shouldShowAllDriversButton?: boolean;
}> = ({
    mappedEntities = { data: [] },
    startDownload = _.noop,
    selection = {} as AutoSuggestSuggestion,
    dateRange = {},
    status = {},
    shouldShowAllDriversButton,
}) => {
    const columns = getColumns(['drivers', 'vehicle', 'tripStartEnd']).concat([downloadColumn]);

    const allButtonState = status?.[`${selection?.id}-all`] === LOADING ? 'btn-loading-overlay' : '';
    return (
        <div className="margin-top-20">
            {Loadable.cata(
                mappedEntities as LoadableType<CoDriverTableEntities[]>,
                data => (
                    <div>
                        <Table
                            key={'coDriver'}
                            filteredColumns={columns}
                            data={data}
                            onSort={_.noop}
                            sortDisabled={true}
                        />
                        {shouldShowAllDriversButton && (
                            <button
                                className={`btn btn-primary ${allButtonState} margin-top-20`}
                                onClick={() =>
                                    startDownload({
                                        type: VEHICLE,
                                        vehicle: selection.entity,
                                        start: dateRange.start,
                                        end: dateRange.end,
                                        isTotalSegment: true,
                                    })
                                }
                            >
                                <FormattedMessage id="coDriver.downloadAll" />
                            </button>
                        )}
                    </div>
                ),
                () => (
                    <div className="margin-top-20">
                        <SimpleErrorState headlineId={'error.default'} messageId={'error.server'} />
                    </div>
                ),
                () => (
                    <Spinner />
                ),
                () => (
                    <EmptyState message={<FormattedMessage id="coDriver.nothingFound" />} />
                )
            )}
        </div>
    );
};

export default TableElement;
